import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paysera/react-common';

export const Apply = ({
    text,
    showModal,
}) => (
    <Button type="button" bsSize="large" className="btn btn-success btn-lg btn-cta button-apply" onClick={showModal}>
        {text}
    </Button>
);

Apply.propTypes = {
    text: PropTypes.string.isRequired,
    showModal: PropTypes.func.isRequired,
};
